import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'venue-list',
  name: '场地列表',
  icon: '场',
  group: '业务组件',
  description: '读取场地数据并渲染客户端场地卡片',
  defaultProps: {
    title: '热门场地',
    limit: 6
}
}
